export const I18N = {
    de: {
        true: 'Ja',
        false: 'Nein'
    },
    en: {
        true: 'Yes',
        false: 'No'
    }
};
